import React, { Fragment, useState, useEffect } from 'react';
import { CSVLink } from 'react-csv';
import WebsiteVisitsChartCard from './WebsiteVisitsChartCard';
import Topic from './Topic';

import Country from './Country';
import ConservationsChartCard from './ConservationsChartCard';
import UserQuestions from './UserQuestions';
import DatePicker from 'react-datepicker';
import 'moment-timezone';
import {
  Row,
  FormGroup,
  Label,
  Col,
  UncontrolledDropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Card
} from 'reactstrap';
import Axios from 'axios';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import {
  week,
  month,
  last7Days,
  last30Days,
  last60Days,
  last90Days,
  LastDays,
  year,
} from './lablesConfig';
import moment from 'moment';
import IntlMessages from '../../../../../helpers/IntlMessages';
import {
  gAPI_Topics_Stats,
  API_CountriesGroups_Stats,
  gAPI_Conversations_VisitorQuestions,
  gAPI_VisitorsGroupsMonth_Stats,
  gAPI_Number_Stats,
  API_Ticket_Stats_ByCategory,
  API_Ingetration_Channels,
  gAPI_Internal_Property_List,
  gAPI_AvatarClick_Stats,
  gAPI_AllPropertyStatsSummary,
  gAPI_Voice_Conversations_Stats,
} from '../../../../../constants/APIs';
import topic from '../../../../../data/topic';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import TicketStatsByCategory from './TicketStatsByCategory';
import NumberTotalConversation from './NumberTotalConversation';
import { injectIntl } from 'react-intl';
const countryDataTableColumns = [
  {
    Header: <IntlMessages id='dashboards.country' />,
    accessor: 'country',
    Cell: (props) => <p className="ml-2">{props.value}</p>,
  },
  {
    Header: <IntlMessages id='dashboards.webVisitors' />,
    accessor: 'visitors',
    Cell: (props) => <p className="ml-5">{props.value}</p>,
  },
  // {
  //   Header: 'Avatar Clicks',
  //   accessor: 'botClicks',
  //   Cell: (props) => <p className="ml-5">{props.value}</p>,
  // },
  {
    Header: <IntlMessages id='menu.conversations' />,
    accessor: 'conversations',
    Cell: (props) => <p className="ml-5">{props.value}</p>,
  },
];

function VoiceStats({
  propertyId,
  isVoucherEngine,
  timeZone,
  domains,
  currency,
  history,
  integrationIdList,

}) {
  moment.tz.setDefault(timeZone);
  const [buttonText, setButtonText] = useState(
    <IntlMessages id="dashboards.last-7-days" />
  );
  const [labels, setLabels] = useState(last7Days);
  const [callStatsData, setCallsStatsData] = useState([]);
  const [topicsStatsData, setTopicsStatsData] = useState([]);
  const [numberStatsData, setNumberStatsData] = useState([]);
  const [countriesStatsData, setCountriesStatsData] = useState([]);
  const [visitorQuestionsData, setvisitorQuestions] = useState([]);
  const [callDurationStatsData, setCallDurationStatsData] = useState([]);
  const [ticketByCategoryData, setTicketByCategoryData] = useState([]);
  const [visitorQuestionsPageSize, setvisitorQuestionsPageSize] = useState(20);
  const [visitorQuestionsPageNumber, setvisitorQuestionsNumber] = useState(1);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [isloading, setLoading] = useState(true);
  const [isWebsiteVisit, setIsWebsiteVisit] = useState(true);
  const [isConversationGraph, setIsConversationGraph] = useState(true);
  const [isTopics, setTopics] = useState(true);
  const [isCountry, setIsCountry] = useState(true);
  const [isUserQuestion, setIsUserQuestion] = useState(true);
  const [isChatTime, setIsChatTime] = useState(true);
  const [totalCalls, setTotalCalls] = useState(0);
  const [isTicketByCategory, setIsTicketByCategory] = useState(true);
  const [isMasked, setIsMasked] = useState(sessionStorage.getItem('lock'));

  const [isShow, setIsShow] = useState(false);
  const [isError, setError] = useState(false);
  const [message, setMessage] = useState('');
  const [filterDate, setFilterDate] = useState(false);
  const [startDate, setStartDate] = useState(moment().subtract(15, 'days'));
  const [endDate, setEndDate] = useState(moment());
  const [propertyData, setPropertyData] = useState(null);
  const [isBusinessOperator, setIsBusinessOperator] = useState(false);
  const [isUtilityProvider, setIsUtilityProvider] = useState(false);

  const [csvData, setCSVData] = useState([]);
  const [topicsError, setTopicsError] = useState(null);
  const [countryError, setCountryError] = useState(null);
  const [numberError, setNumberError] = useState(null);
  const [visitorError, setVisitorError] = useState(null);
  const [voiceError, setVoiceError] = useState(null);
  const [ticketError, setTicketError] = useState(null);

  const StatContainer = ({ onRefresh, error, children }) => {

    return (
      <div>
        {error ? (
          <Card className="text-center my-3" style={{ padding: '100px' }}>
            <p style={{ color: 'red' }}>{error}</p>

            <i className='iconsminds-refresh' style={{ fontSize: '40px', color: 'grey' }}
              onClick={onRefresh}
            />

          </Card>
        ) : (
          children
        )}
      </div>
    );
  };
  const fetchTopicsStats = async (fromDate, toDate) => {
    setTopicsError(null);
    setTopics(true);
    try {
      const res = await AxiosAPI({
        method: 'get',
        url: `${gAPI_Topics_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: fromDate,
          dateTo: toDate,
          propertyId: propertyId,
          isVoice: true,
        },
      });
      setTopicsStatsData(res.data);
    } catch (error) {
      console.error(error);
      setTopicsError('Failed to load Topics stats.');
    } finally {
      setTopics(false);
    }
  };

  const fetchCountriesStats = async (fromDate, toDate) => {
    setCountryError(null);
    setIsCountry(true);
    try {
      const res = await AxiosAPI({
        method: 'post',
        url: `${API_CountriesGroups_Stats}`,
        data: {
          groupId: getGroupID(),
          dateFrom: fromDate,
          dateTo: toDate,
          propertyId: propertyId,
          integrationIds: integrationIdList,
        },
      });
      setCountriesStatsData(res.data);
    } catch (error) {
      console.error(error);
      setCountryError('Failed to load Country stats.');
    } finally {
      setIsCountry(false);
    }
  };

  const fetchNumberStats = async (fromDate, toDate) => {
    setNumberError(null);
    setIsChatTime(true);
    try {
      const res = await AxiosAPI({
        method: 'get',
        url: `${gAPI_Number_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: fromDate,
          dateTo: toDate,
          propertyId: propertyId,
        },
      });
      setNumberStatsData(res.data);
    } catch (error) {
      console.error(error);
      setNumberError('Failed to load Number stats.');
    } finally {
      setIsChatTime(false);
    }
  };

  const fetchVoiceConversationsStats = async (fromDate, toDate) => {
    let monthWise = false;
    if (fromDate === startOfThisYear() || fromDate === startOfLastYear()) {
      monthWise = true;
    }
    setVoiceError(null);
    setIsConversationGraph(true);
    setIsWebsiteVisit(false);
    try {
      const res = await AxiosAPI({
        method: 'get',
        url: `${gAPI_Voice_Conversations_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: fromDate,
          dateTo: toDate,
          propertyId: propertyId,
          monthWise: monthWise,
        },
      });
      if (res.data?.callDurations)
        setCallDurationStatsData(res.data.callDurations);
      if (res.data?.calls) {
        let count = 0;
        res.data.calls.map((m) => (count += m.count));
        setTotalCalls(count);
        setCallsStatsData(res.data.calls);
      }
    } catch (error) {
      console.error(error);
      setVoiceError('Failed to load Voice stats.');
    } finally {
      setIsConversationGraph(false);
      setIsWebsiteVisit(false);
    }
  };

  const fetchVisitorQuestions = async (fromDate, toDate) => {
    setVisitorError(null);
    setIsUserQuestion(true);
    setLoading(true);
    try {
      const res = await AxiosAPI({
        method: 'get',
        url: `${gAPI_Conversations_VisitorQuestions}`,
        params: {
          groupId: getGroupID(),
          dateFrom: fromDate,
          dateTo: toDate,
          pageNumber: visitorQuestionsPageNumber,
          pageSize: visitorQuestionsPageSize,
          propertyId: propertyId,
          isVoice: true,
        },
      });
      setvisitorQuestions(res.data);
    } catch (error) {
      console.error(error);
      setVisitorError('Failed to load visitor stats.')
    } finally {
      setIsUserQuestion(false);
    }
  };

  const fetchTicketByCategory = async (fromDate, toDate) => {
    setTicketError(null);
    setIsTicketByCategory(true);
    try {
      const res = await AxiosAPI({
        method: 'post',
        url: `${API_Ticket_Stats_ByCategory}`,
        data: {
          groupId: getGroupID(),
          propertyId: propertyId,
          dateFrom: fromDate,
          dateTo: toDate,
          integrationIds: integrationIdList,
        },
      });
      setTicketByCategoryData(res.data);
    } catch (error) {
      console.error(error);
      setTicketError('Failed to load Ticket stats.')
    } finally {
      setIsTicketByCategory(false);
    }
  };

  const maskEmail = (text) => {
    if (text !== null && text !== undefined) {
      let maskedvalue = text.replace(/()(.*)(?=@)/, function (gp1, gp2, gp3) {
        for (let i = 0; i < gp3.length; i++) {
          gp2 += 'X';
        }
        return gp2;
      });
      return maskedvalue;
    } else return '';
  };
  const maskMobile = (text, number) => {
    if (text !== null && text !== undefined) {
      let maskedValue = '';
      for (let i = 0; i < text.length - number; i++) {
        maskedValue += 'X';
      }
      return maskedValue + text.substring(text.length - number, text.length);
    } else return '';
  };

  const dataTableTicketByCategoryColumns = [
    {
      Header: <IntlMessages id='dashboards.category' />,
      accessor: 'category',
      Cell: (props) => (
        <p className="ml-2">
          <a
            className="btn-link"
            style={{ textDecoration: 'underline' }}
            onClick={() => handleNavigateToTicket(props.value)}
          >
            {props.value}
          </a>
        </p>
      ),
    },
    {
      Header: <IntlMessages id='dashboards.ticket-count' />,
      accessor: 'ticketCount',
      Cell: (props) => <p className="ml-3">{props.value}</p>,
    },
  ];

  const handleNavigateToTicket = (value) => {
    history.push({
      pathname: '/app/pages/agent-assist',
      state: { categoryvalue: value },
    });
  };

  const handleMaskClick = () => {
    if (isMasked === 'true') {
      sessionStorage.setItem('lock', 'false');
      setIsMasked(sessionStorage.getItem('lock'));
    } else {
      sessionStorage.setItem('lock', 'true');
      setIsMasked(sessionStorage.getItem('lock'));
    }
  };
  const handlenavbooking = (value) => {
    history.push({
      pathname: '/app/pages/agent-assist',
      state: { tagName: value },
    });
  };
  const dataTableColumns = [
    {
      Header: <IntlMessages id='content.topics' />,
      accessor: 'topic',
      Cell: (props) => (
        <p className="ml-2">
          {topic.filter((e) => e.topic === props.value).length > 0 ? (
            <a
              className="btn-link"
              style={{ textDecoration: 'underline' }}
              onClick={() => handlenavbooking(props.value)}
            >
              {props.value}
            </a>
          ) : (
            props.value
          )}
        </p>
      ),
    },
    {
      Header: <IntlMessages id='menu.conversations' />,
      accessor: 'conversations',
      Cell: (props) => <p className="ml-5">{props.value}</p>,
    },
    {
      Header: <IntlMessages id='chat.messages' />,
      accessor: 'messages',
      Cell: (props) => <p className="ml-5">{props.value}</p>,
    },
  ];

  useEffect(() => {
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_Internal_Property_List}?group_id=${getGroupID()}`,
    }).then((res) => {
      var allproperties = res.data;
      var isLocal = false;
      if (propertyId === '-1') {
        var totalwageRate = 0;
        var totalwageRateUSD = 0;
        var currency = '';
        var currencyProperty = allproperties.filter(
          (n) => n.currency !== null && n.currency !== ''
        );
        const allEqual = currencyProperty.every(
          (val) => val === currencyProperty[0]
        );
        if (allproperties.length === currencyProperty.length) {
          if (allEqual) {
            currency = currencyProperty[0].currency;
          } else {
            currency = 'USD';
          }
        }
        var hourly = allproperties.filter(
          (n) =>
            n.averageHourlyWageRate !== null && n.averageHourlyWageRate !== 0
        );
        if (allproperties.length === hourly.length) {
          totalwageRate = hourly[0].averageHourlyWageRate;
        }
        var hourlyUSD = allproperties.filter(
          (n) =>
            n.averageHourlyWageRateUSD !== null &&
            n.averageHourlyWageRateUSD !== 0
        );
        if (allproperties.length === hourlyUSD.length) {
          totalwageRateUSD = hourlyUSD[0].averageHourlyWageRateUSD;
        }

        var body = {
          currency: currency,
          totalwageRate: totalwageRate,
          totalwageRateUSD: totalwageRateUSD,
          isLocal: isLocal,
          isGroupLevel: true,
        };
        setPropertyData(body);
      } else {
        var propertydata = allproperties.filter((m) => m.id == propertyId);
        if (propertydata !== null && propertydata.length > 0) {
          var totalwageRate = propertydata[0].averageHourlyWageRate;
          var totalwageRateUSD = propertydata[0].averageHourlyWageRateUSD;
          var currency = propertydata[0].currency;
          var body = {
            currency: currency,
            totalwageRate: totalwageRate,
            totalwageRateUSD: totalwageRateUSD,
            isLocal: isLocal,
            isGroupLevel: false,
          };
          setPropertyData(body);
        }
      }
    });

    selectLast7Days();
    let body = {
      channels: ['BookingEngineUrl', 'HelpCenter', 'HelpCenterGroup'],
    };
    AxiosAPI({
      method: 'post',
      url: `${API_Ingetration_Channels}?group_id=${getGroupID()}`,
      data: body,
    }).then((res) => { });
  }, [propertyId]);

  const today = () => {
    return moment(moment().format('YYYY-MM-DD') + ' 23:59:59')
      .utc()
      .format('YYYY-MM-DD HH:mm:ss');
  };

  const daysAgo7 = () => {
    return moment(moment().subtract(6, 'days').format('YYYY-MM-DD HH:mm:ss'))
      .utc()
      .format('YYYY-MM-DD 00:00:00');
  };

  const daysAgo30 = () => {
    return moment(moment().subtract(29, 'days').format('YYYY-MM-DD HH:mm:ss'))
      .utc()
      .format('YYYY-MM-DD 00:00:00');
  };

  const daysAgo60 = () => {
    return moment(moment().subtract(59, 'days').format('YYYY-MM-DD HH:mm:ss'))
      .utc()
      .format('YYYY-MM-DD 00:00:00');
  };

  const daysAgo90 = () => {
    return moment(moment().subtract(89, 'days').format('YYYY-MM-DD HH:mm:ss'))
      .utc()
      .format('YYYY-MM-DD 00:00:00');
  };

  const startOfWeek = () => {
    const today = moment();
    return moment(moment(today).isoWeekday(1).format('YYYY-MM-DD HH:mm:ss'))
      .utc()
      .format('YYYY-MM-DD 00:00:00');
  };

  const endOfWeek = () => {
    const today = moment();
    return moment(
      moment(today).isoWeekday(7).format('YYYY-MM-DD') + ' 23:59:59'
    )
      .utc()
      .format('YYYY-MM-DD HH:mm:ss');
  };

  const startOfMonth = () => {
    return moment(moment().startOf('month').format('YYYY-MM-DD HH:mm:ss'))
      .utc()
      .format('YYYY-MM-DD 00:00:00');
  };

  const startOfPreviousMonth = () => {
    return moment(
      moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD') +
      ' 00:00:00'
    )
      .utc()
      .format('YYYY-MM-DD HH:mm:ss');
  };

  const startOfThisYear = () => {
    return moment(new Date().getFullYear() + '-01-01' + ' 00:00:00').format(
      'YYYY-MM-DD HH:mm:ss'
    );
  };

  const startOfLastYear = () => {
    return moment(new Date().getFullYear() - 1 + '-01-01' + ' 00:00:00').format(
      'YYYY-MM-DD HH:mm:ss'
    );
  };
  const endOfLastYear = () => {
    return moment(new Date().getFullYear() - 1 + '-12-31' + ' 00:00:00').format(
      'YYYY-MM-DD HH:mm:ss'
    );
  };

  const endOfPreviousMonth = () => {
    return moment(
      moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD') +
      ' 23:59:59'
    )
      .utc()
      .format('YYYY-MM-DD HH:mm:ss');
  };
  const loadMore = () => {
    const currentPage = visitorQuestionsPageNumber + 1;
    setvisitorQuestionsNumber(currentPage);
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Conversations_VisitorQuestions}`,
      params: {
        groupId: getGroupID(),
        dateFrom: fromDate,
        dateTo: toDate,
        pageNumber: currentPage,
        pageSize: visitorQuestionsPageSize,
        propertyId: propertyId,
        isVoice: true,
      },
    }).then((res) => {
      setLoading(true);
      const data = [...visitorQuestionsData, ...res.data];
      setvisitorQuestions(data);
    });
  };

  const endOfMonth = () => {
    return moment(moment().endOf('month').format('YYYY-MM-DD') + ' 23:59:59')
      .utc()
      .format('YYYY-MM-DD HH:mm:ss');
  };

  const handleStartDate = (date) => {
    setStartDate(moment(date));
  };

  const handleEndDate = (date) => {
    setEndDate(moment(date));
  };
  const selectLast7Days = async () => {
    const from = daysAgo7();
    const to = today();

    if (propertyId === '-1') downloadSummaryAll(from, to);

    setFilterDate(false);
    setButtonText(<IntlMessages id="dashboards.last-7-days" />);
    setLabels(last7Days);
    setvisitorQuestionsNumber(1);
    setvisitorQuestionsPageSize(10);
    setFromDate(from);
    setToDate(to);

    fetchTopicsStats(from, to);
    // fetchCountriesStats(from, to);
    fetchNumberStats(from, to);
    fetchVoiceConversationsStats(from, to);
    fetchVisitorQuestions(from, to);
    fetchTicketByCategory(from, to);
  };

  const selectLast30Days = async () => {
    const from = daysAgo30();
    const to = today();

    if (propertyId === '-1') downloadSummaryAll(from, to);

    setFilterDate(false);
    setButtonText(<IntlMessages id="dashboards.last-30-days" />);
    setLabels(last30Days);
    setvisitorQuestionsNumber(1);
    setvisitorQuestionsPageSize(10);
    setFromDate(from);
    setToDate(to);

    fetchTopicsStats(from, to);
    // fetchCountriesStats(from, to);
    fetchNumberStats(from, to);
    fetchVoiceConversationsStats(from, to);
    fetchVisitorQuestions(from, to);
    fetchTicketByCategory(from, to);
  };

  const selectLast60Days = async () => {
    const from = daysAgo60();
    const to = today();

    if (propertyId === '-1') downloadSummaryAll(from, to);

    setFilterDate(false);
    setButtonText(<IntlMessages id="dashboards.last-60-days" />);
    setLabels(last60Days);
    setvisitorQuestionsNumber(1);
    setvisitorQuestionsPageSize(10);
    setFromDate(from);
    setToDate(to);

    fetchTopicsStats(from, to);
    // fetchCountriesStats(from, to);
    fetchNumberStats(from, to);
    fetchVoiceConversationsStats(from, to);
    fetchVisitorQuestions(from, to);
    fetchTicketByCategory(from, to);
  };

  const selectLast90Days = async () => {
    const from = daysAgo90();
    const to = today();

    if (propertyId === '-1') downloadSummaryAll(from, to);

    setFilterDate(false);
    setButtonText(<IntlMessages id="dashboards.last-90-days" />);
    setLabels(last90Days);
    setvisitorQuestionsNumber(1);
    setvisitorQuestionsPageSize(10);
    setFromDate(from);
    setToDate(to);

    fetchTopicsStats(from, to);
    // fetchCountriesStats(from, to);
    fetchNumberStats(from, to);
    fetchVoiceConversationsStats(from, to);
    fetchVisitorQuestions(from, to);
    fetchTicketByCategory(from, to);
  };
  const handleFilterDateWise = async (startDate, endDate) => {
    const from = startDate;
    const to = endDate;
    setvisitorQuestionsNumber(1);
    setvisitorQuestionsPageSize(10);
    setFromDate(from);
    setToDate(to);

    fetchTopicsStats(from, to);
    // fetchCountriesStats(from, to);
    fetchNumberStats(from, to);
    fetchVoiceConversationsStats(from, to);
    fetchVisitorQuestions(from, to);
    fetchTicketByCategory(from, to);
  }
  const selectThisWeek = async () => {
    const from = startOfWeek();
    const to = endOfWeek();

    if (propertyId === '-1') downloadSummaryAll(from, to);

    setFilterDate(false);
    setButtonText(<IntlMessages id="dashboards.this-week" />);
    setLabels(week);
    setvisitorQuestionsNumber(1);
    setvisitorQuestionsPageSize(10);
    setFromDate(from);
    setToDate(to);

    fetchTopicsStats(from, to);
    // fetchCountriesStats(from, to);
    fetchNumberStats(from, to);
    fetchVoiceConversationsStats(from, to);
    fetchVisitorQuestions(from, to);
    fetchTicketByCategory(from, to);
  };

  const selectThisMonth = async () => {
    const from = startOfMonth();
    const to = endOfMonth();

    if (propertyId === '-1') downloadSummaryAll(from, to);

    setButtonText(<IntlMessages id="dashboards.this-month" />);
    setLabels(month);
    setFilterDate(false);
    setvisitorQuestionsNumber(1);
    setvisitorQuestionsPageSize(10);
    setFromDate(from);
    setToDate(to);

    fetchTopicsStats(from, to);
    // fetchCountriesStats(from, to);
    fetchNumberStats(from, to);
    fetchVoiceConversationsStats(from, to);
    fetchVisitorQuestions(from, to);
    fetchTicketByCategory(from, to);
  };
  const selectPreviousMonth = async () => {
    const from = startOfPreviousMonth();
    const to = endOfPreviousMonth();


    if (propertyId === '-1') downloadSummaryAll(from, to);

    setFilterDate(false);
    setButtonText(<IntlMessages id="dashboards.previous-month" />);
    setLabels(month);
    setvisitorQuestionsNumber(1);
    setvisitorQuestionsPageSize(10);
    setFromDate(from);
    setToDate(to);

    fetchTopicsStats(from, to);
    // fetchCountriesStats(from, to);
    fetchNumberStats(from, to);
    fetchVoiceConversationsStats(from, to);
    fetchVisitorQuestions(from, to);
    fetchTicketByCategory(from, to);
  };
  const selectThisYear = async () => {
    const from = startOfThisYear();
    const to = today();


    if (propertyId === '-1') downloadSummaryAll(from, to);

    setButtonText(<IntlMessages id="dashboards.yeartodate" />);
    setLabels(year);
    setFilterDate(false);
    setvisitorQuestionsNumber(1);
    setvisitorQuestionsPageSize(10);
    setFromDate(from);
    setToDate(to);

    fetchTopicsStats(from, to);
    // fetchCountriesStats(from, to);
    fetchNumberStats(from, to);
    fetchVoiceConversationsStats(from, to);
    fetchVisitorQuestions(from, to);
    fetchTicketByCategory(from, to);

  };

  const selectLastYear = async () => {
    const from = startOfLastYear();
    const to = endOfLastYear();


    if (propertyId === '-1') downloadSummaryAll(from, to);

    setFilterDate(false);
    setButtonText(<IntlMessages id="dashboards.lastyear" />);
    setLabels(year);
    setvisitorQuestionsNumber(1);
    setvisitorQuestionsPageSize(10);
    setFromDate(from);
    setToDate(to);

    fetchTopicsStats(from, to);
    // fetchCountriesStats(from, to);
    fetchNumberStats(from, to);
    fetchVoiceConversationsStats(from, to);
    fetchVisitorQuestions(from, to);
    fetchTicketByCategory(from, to);

  };

  const handleFilterMonthWise = (startDate, endDate) => {
    if (propertyId === '-1') {
      downloadSummaryAll(startOfLastYear(), endOfLastYear());
    }
    setLabels(year);
    setvisitorQuestionsNumber(1);
    setvisitorQuestionsPageSize(10);
    setFromDate(startOfLastYear());
    setToDate(endOfLastYear());
    setTopics(true);
    setIsCountry(false);

    setIsChatTime(true);
    setIsWebsiteVisit(false);
    setIsConversationGraph(true);

    setIsTicketByCategory(true);
    Axios.all([
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Topics_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startDate,
          dateTo: endDate,
          isVoice: true,
          propertyId: propertyId,
        },
      }).then((res) => {
        setTopicsStatsData(res.data);
        setTopics(false);
      }),

      // AxiosAPI({
      //   method: 'post',
      //   url: `${API_CountriesGroups_Stats}`,
      //   data: {
      //     groupId: getGroupID(),
      //     dateFrom: startDate,
      //     dateTo: endDate,
      //     propertyId: propertyId,
      //     integrationIds: integrationIdList,
      //   },
      // }).then((res) => {
      //   setCountriesStatsData(res.data);
      //   setIsCountry(false);
      // }),

      AxiosAPI({
        method: 'get',
        url: `${gAPI_Number_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startDate,
          dateTo: endDate,
          propertyId: propertyId,
        },
      }).then((res) => {
        setNumberStatsData(res.data);
        setIsChatTime(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voice_Conversations_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startDate,
          dateTo: endDate,
          propertyId: propertyId,
          monthWise: false,
        },
      }).then((res) => {
        if (res.data?.callDurations)
          setCallDurationStatsData(res.data.callDurations);
        if (res.data?.calls) {
          let count = 0;
          res.data.calls.map((m) => (count += m.count));
          setTotalCalls(count);
          setCallsStatsData(res.data.calls);
        }
        setIsConversationGraph(false);
        setIsWebsiteVisit(false);
      }),

      AxiosAPI({
        method: 'get',
        url: `${gAPI_Conversations_VisitorQuestions}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startDate,
          dateTo: endDate,
          pageNumber: visitorQuestionsPageNumber,
          pageSize: visitorQuestionsPageSize,
          propertyId: propertyId,
          isVoice: true,
        },
      }).then((res) => {
        setLoading(true);
        setvisitorQuestions(res.data);
        setIsUserQuestion(false);
      }),

      AxiosAPI({
        method: 'post',
        url: `${API_Ticket_Stats_ByCategory}`,
        data: {
          groupId: getGroupID(),
          propertyId: propertyId,
          dateFrom: startDate,
          dateTo: endDate,
          integrationIds: integrationIdList,
        },
      }).then((res) => {
        setTicketByCategoryData(res.data);
        setIsTicketByCategory(false);
      }),
    ]);
  };

  const handleFilter = () => {
    let diff = endDate.diff(startDate, 'days');
    setButtonText('Date Range');
    if (diff > 365) {
      setMessage('The start and end date must be within a year of each other.');
      setError(true);
      return;
    }
    if (diff > 90) {
      setIsShow(false);
      setLabels(year);
      handleFilterMonthWise(
        moment(startDate).format('YYYY-MM-DD 00:00:00'),
        moment(endDate).format('YYYY-MM-DD') + ' 23:59:59'
      );
      setFilterDate(true);
    } else {
      if (diff >= 60) setLabels(LastDays(startDate, endDate));
      else if (diff >= 30) setLabels(LastDays(startDate, endDate));
      else if (diff >= 7) setLabels(LastDays(startDate, endDate));
      else setLabels(LastDays(startDate, endDate));
      setIsShow(false);
      handleFilterDateWise(
        moment(startDate).format('YYYY-MM-DD 00:00:00'),
        moment(endDate).format('YYYY-MM-DD') + ' 23:59:59'
      );
      setFilterDate(true);
    }
  };
  if (Array.isArray(domains) && isBusinessOperator === false) {
    domains.forEach((r) => {
      if (r.type === 'BusinessOperator') {
        setIsBusinessOperator(true);
      }
    });
  }
  if (Array.isArray(domains) && isUtilityProvider === false) {
    domains.forEach((r) => {
      if (r.type === 'UtilityProviders') {
        setIsUtilityProvider(true);
      }
    });
  }
  const downloadSummaryAll = (datefrom, dateto) => {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_AllPropertyStatsSummary}`,
      params: {
        groupId: getGroupID(),
        dateFrom: datefrom,
        dateTo: dateto,
      },
    }).then((res) => {
      var tablePrint = [
        {
          r1: 'Start Date :' + datefrom,
          r2: '',
          r3: 'End Date :' + dateto,
          r4: '',
          r5: '',
          r6: '',
          r7: '',
          r8: '',
          r9: '',
          r10: '',
          r11: '',
          r12: '',
          r13: '',
          r14: '',
          r15: '',
          r16: '',
          r17: '',
        },
        {},
        {
          r1: 'Property',
          r2: 'Estimated Time Saving (Hours)',
          r3: 'Estimated Time Saving (NZD)',
          r4: 'Avatar Clicks',
          r5: 'Total Conversations',
          r6: 'Total User Messages',
          r7: 'Website Conversations',
          r8: 'WhatsApp Conversations',
          r9: 'Facebook Conversations',
          r10: 'Insta Conversations',
          r11: 'Tickets',
          r12: 'Contact',
          r13: 'Consented Contacts',
          r14: 'Booking Engine Leads',
          r15: 'Room Nights Referred',
          r16: 'Room Revenue Referred (NZD)',
          r17: 'Room Revenue Referred (USD)',
        },
      ];
      if (res.data.length > 0 && res.data.length > 0) {
        res.data.map((elem) => {
          tablePrint.push({
            r1: elem.propertyName,
            r2: elem.estimateTimeSavingHours,
            r3: elem.estimateTimeSavingNZD,
            r4: elem.totalAvatarClicks,
            r5: elem.totalConversations,
            r6: elem.totalUsersMessages,
            r7: elem.websiteConversations,
            r8: elem.whatsAppConversations,
            r9: elem.facebookConversations,
            r10: elem.instagramConversations,
            r11: elem.tickets,
            r12: elem.contacts,
            r13: elem.consentsContacts,
            r14: elem.bookingEngineLeads,
            r15: elem.roomNightsReferred,
            r16: elem.roomsRevenueReferredNZD,
            r17: elem.roomsRevenueReferredUSD,
          });
        });
      }
      setCSVData(tablePrint);
    });
  };
  return (
    <Fragment>
      <Row>
        <Col xxs="12" className="mb-2">
          <Fragment>
            {filterDate === true && (
              <div className="float-left mt-2">
                <span className="mr-2">
                  <b>From : </b>
                  {moment(startDate).format('DD')}/
                  {moment(startDate).format('MM')}/
                  {moment(startDate).format('YYYY')}
                </span>
                <span className="ml-2">
                  <b>To : </b>
                  {moment(endDate).format('DD')}/{moment(endDate).format('MM')}/
                  {moment(endDate).format('YYYY')}
                </span>
              </div>
            )}
            <div className="btn-group float-right float-none-xs mb-3">
              {propertyId === '-1' && (
                <CSVLink
                  data={csvData}
                  headers={[
                    { key: 'r1', label: '' },
                    { key: 'r2', label: '' },
                    { key: 'r3', label: '' },
                    { key: 'r4', label: '' },
                    { key: 'r5', label: '' },
                    { key: 'r6', label: '' },
                    { key: 'r7', label: '' },
                    { key: 'r8', label: '' },
                    { key: 'r9', label: '' },
                    { key: 'r10', label: '' },
                    { key: 'r11', label: '' },
                    { key: 'r12', label: '' },
                    { key: 'r13', label: '' },
                    { key: 'r14', label: '' },
                    { key: 'r15', label: '' },
                    { key: 'r16', label: '' },
                    { key: 'r17', label: '' },
                  ]}
                  filename="summary-stats.csv"
                >
                  <Button color="primary" outline size="xs" className="mr-2">
                    Download Summary
                  </Button>
                </CSVLink>
              )}
              <UncontrolledDropdown>
                <DropdownToggle
                  caret
                  color="primary"
                  className="btn-xs"
                  outline
                >
                  {buttonText}
                </DropdownToggle>
                <DropdownMenu right>
                  <DropdownItem onClick={selectLast7Days}>
                    <IntlMessages id="dashboards.last-7-days" />
                  </DropdownItem>
                  <DropdownItem onClick={selectLast30Days}>
                    <IntlMessages id="dashboards.last-30-days" />
                  </DropdownItem>
                  <DropdownItem onClick={selectLast60Days}>
                    <IntlMessages id="dashboards.last-60-days" />
                  </DropdownItem>
                  <DropdownItem onClick={selectLast90Days}>
                    <IntlMessages id="dashboards.last-90-days" />
                  </DropdownItem>
                  <DropdownItem onClick={selectThisWeek}>
                    <IntlMessages id="dashboards.this-week" />
                  </DropdownItem>
                  <DropdownItem onClick={selectThisMonth}>
                    <IntlMessages id="dashboards.this-month" />
                  </DropdownItem>
                  <DropdownItem onClick={selectPreviousMonth}>
                    <IntlMessages id="dashboards.previous-month" />
                  </DropdownItem>
                  <DropdownItem onClick={selectThisYear}>
                    <IntlMessages id="dashboards.yeartodate" />
                  </DropdownItem>
                  <DropdownItem onClick={selectLastYear}>
                    <IntlMessages id="dashboards.lastyear" />
                  </DropdownItem>
                  <DropdownItem onClick={() => setIsShow(!isShow)}>
                    <IntlMessages id="form-components.date-range" />
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </div>
          </Fragment>
        </Col>
      </Row>
      <Row>
        {!isVoucherEngine || domains.length > 1 ? (
          <Col sm="12" md="12" className="mb-4">
            <StatContainer
              error={numberError}
              onRefresh={() => fetchNumberStats(fromDate, toDate)}
            >
              {isChatTime ? (
                <div className="text-center loading" />
              ) : (
                <Fragment>
                  <NumberTotalConversation
                    history={history}
                    numbertimedata={numberStatsData}
                    fromDate={fromDate}
                    toDate={toDate}
                    isVoice={true}
                    messengerAvatar={
                      totalCalls
                      //isMessengerConnect ? messengerClickData.avatarClick : null
                    }
                  />
                </Fragment>
              )}
            </StatContainer>
          </Col>
        ) : (
          ''
        )}
        <Col sm="12" md="6" className="mb-4">
          <StatContainer
            error={voiceError}
            onRefresh={() => fetchVoiceConversationsStats(fromDate, toDate)}
          >
            {isWebsiteVisit ? (
              <div className="text-center">
                <div className="text-center loading" />
              </div>
            ) : (
              <WebsiteVisitsChartCard
                labels={labels}
                isVoice={true}
                visitorStatsData={callStatsData}
              />
            )}
          </StatContainer>
        </Col>
        {!isVoucherEngine || domains.length > 1 ? (
          <Col sm="12" md="6" className="mb-4">
            <StatContainer
              error={voiceError}
              onRefresh={() => fetchVoiceConversationsStats(fromDate, toDate)}
            >
              {isConversationGraph ? (
                <div className="text-center loading" />
              ) : (
                <ConservationsChartCard
                  labels={labels}
                  isVoice={true}
                  conversationStatsData={callDurationStatsData}
                  conversationNightStatsData={[]}
                  fromDate={fromDate}
                  toDate={toDate}
                  chattimeStatsData={[]}
                  chattimeNightStatsData={[]}
                  visitorStatsData={callStatsData}
                  avatarclickdata={[]}
                />
              )}
            </StatContainer>
          </Col>
        ) : (
          ''
        )}
        {/* {!isVoucherEngine || domains.length > 1 ? (
          <Col sm="12" md="6" className="mb-4">
           <StatContainer
              error={countryError}
              onRefresh={() => fetchCountriesStats(fromDate, toDate)}
            >
            {isCountry ? (
              <div className="text-center loading" />
            ) : (
              <Country
                isVoice={true}
                labels={countryDataTableColumns}
                data={countriesStatsData}
                fromDate={fromDate}
                toDate={toDate}
              />
            )}
               </StatContainer>
          </Col>
        ) : (
          ''
        )} */}
        {!isVoucherEngine || domains.length > 1 ? (
          <Col sm="12" md="6" className="mb-4">
            <StatContainer
              error={topicsError}
              onRefresh={() => fetchTopicsStats(fromDate, toDate)}
            >
              {isTopics ? (
                <div className="text-center loading" />
              ) : (
                <Topic
                  labels={dataTableColumns}
                  data={topicsStatsData}
                  fromDate={fromDate}
                  toDate={toDate}
                />
              )}
            </StatContainer>
          </Col>
        ) : (
          ''
        )}

        {!isVoucherEngine || domains.length > 1 ? (
          <Col sm="12" md="6" className="mb-4">
            <StatContainer
              error={visitorError}
              onRefresh={() => fetchVisitorQuestions(fromDate, toDate)}
            >
              {isUserQuestion ? (
                <div className="text-center loading" />
              ) : (
                <UserQuestions
                  data={visitorQuestionsData}
                  isloading={isloading}
                  loadMore={loadMore}
                  fromDate={fromDate}
                  toDate={toDate}
                />
              )}
            </StatContainer>
          </Col>
        ) : (
          ''
        )}

        {!isVoucherEngine || domains.length > 1 ? (
          <Col sm="12" md="6" className="mb-4">
            <StatContainer
              error={ticketError}
              onRefresh={() => fetchTicketByCategory(fromDate, toDate)}
            >
              {isTicketByCategory ? (
                <div className="text-center loading" />
              ) : (
                <TicketStatsByCategory
                  labels={dataTableTicketByCategoryColumns}
                  data={ticketByCategoryData}
                  fromDate={fromDate}
                  toDate={toDate}
                />
              )}
            </StatContainer>
          </Col>
        ) : (
          ''
        )}
      </Row>

      <Modal
        isOpen={isShow}
        toggle={() => setIsShow(!isShow)}
        style={{ borderRadius: '10px' }}
      >
        <ModalHeader toggle={() => setIsShow(!isShow)}><IntlMessages id="form-components.date-range" /></ModalHeader>
        <ModalBody>
          <Row>
            <Colxx md="4" className="mb-2">
              <FormGroup>
                <Label><IntlMessages id='dashboards.start-date' /></Label>
                <DatePicker
                  style={{ borderRadius: "10px" }}
                  selected={startDate ? new Date(startDate) : null} // ensure Date object
                  onChange={handleStartDate}
                  placeholderText="Start Date"
                  dateFormat="dd/MM/yyyy"   // ✅ correct format
                />
              </FormGroup>
            </Colxx>

            <Colxx md="4" className="mb-2">
              <FormGroup>
                <Label> <IntlMessages id='dashboards.end-date' /></Label>
                <DatePicker
                  style={{ borderRadius: "10px" }}
                  selected={endDate ? new Date(endDate) : null} // ✅ always Date object
                  onChange={handleEndDate}
                  placeholderText="End Date"
                  dateFormat="dd/MM/yyyy"   // ✅ correct format
                />
              </FormGroup>
            </Colxx>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={() => handleFilter()}>
            Submit
          </Button>
          <Button className="ml-2" onClick={() => setIsShow(!isShow)}>
            Close
          </Button>
        </ModalFooter>
      </Modal>

      <Modal
        isOpen={isError}
        toggle={() => setError(!isError)}
        style={{ borderRadius: '10px' }}
      >
        <ModalHeader toggle={() => setError(!isError)}>BOOKMEBOB</ModalHeader>
        <ModalBody>
          <Row>
            <p className="m-2">{message}</p>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button className="ml-2" onClick={() => setError(!isError)}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
}
export default injectIntl(VoiceStats);